<template>
  <div v-if="data" class="payment-card">
    <div class="payment-card__logo">
      <template
        v-if="
          data.transaction_type !== 'SHOP' &&
          (!operationTypeLogos[data.operation_type] ||
            operationTypeLogos[data.operation_type] === 'custom')
        "
      >
        <img
          :src="`${cdnUrl}${data.merchant_id}.png`"
          @error="setAltImg($event, data.merchant_location)"
        />
        <div
          v-if="data.buying_status === 'Canceled'"
          class="payment-card__logo--cancel i-close-circle-filled"
        ></div>
      </template>
      <div
        v-else-if="data.transaction_type === 'SHOP'"
        :class="operationTypeLogos[data.transaction_type]"
      ></div>
      <div v-else :class="operationTypeLogos[data.operation_type]"></div>
      <div
        v-if="data.buying_status === 'Canceled'"
        class="payment-card__logo--cancel i-close-circle-filled"
      ></div>
    </div>
    <div class="payment-card__content">
      <div class="payment-card__content_text">
        <div
          class="payment-card__title"
          :class="{
            'payment-card__title--multiline': multiline,
          }"
          v-html="
            data.operation_type === 'TRANSFER'
              ? $t`Перевод остатка</br>на Kaspi Gold`
              : $gettext(data.merchant_location)
          "
        ></div>
        <div class="payment-card__amount">
          <div v-if="data.is_hold">
            <div class="payment-card__amount_hold text-grey">
              <div :class="isHoldTypeIcon"></div>
              <div
                :style="{
                  padding: `0 0 0 4px`,
                }"
              >
                - {{ $currencyFormatter(Math.ceil(Math.abs(data.amount))) }}
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="payment-card__amount_overall"
              :class="{
                'text-green':
                  !data.is_expense || data.buying_status === 'Canceled',
              }"
            >
              <template
                v-if="!data.is_expense || data.buying_status === 'Canceled'"
              >
                +
              </template>
              <template v-else>-</template>
              {{ $currencyFormatter(Math.ceil(Math.abs(data.amount))) }}
            </div>
          </div>

          <div
            v-if="data.bonus_percent > 0"
            class="payment-card__amount_bonus text-size-xs text-green text-right font-bonus"
          >
            + {{ getBonusAmount(data.amount, data.bonus_percent) }}
          </div>
        </div>
      </div>
      <div
        v-if="isOperType"
        class="payment-card__content_hint text-size-xs"
        :class="`${data.buying_status === 'Paid' ? 'text-green' : 'text-grey'}`"
      >
        <template v-if="data.buying_status === 'Paid'">
          {{ $t`Полностью оплачено` }}
        </template>
        <template v-else-if="data.buying_status === 'Canceled'">
          {{ $t`Отмена покупки` }}
        </template>
        <template v-else>
          {{
            $l10nformat($t`Осталось #DEBT# из #OVERALL#`, {
              DEBT: $currencyFormatter(data.left_to_pay_sum),
              OVERALL: $currencyFormatter(data.amount),
            })
          }}
        </template>
      </div>
      <div
        v-if="isOperType && data.buying_status === 'Not_paid'"
        class="payment-card__content_progress"
      >
        <div
          v-for="payment in data.red_payments"
          :key="payment.plane_date"
          class="progress-block"
        >
          <div class="progress-block__mask">
            <div
              class="progress-block__mask_filler"
              :style="{
                width: `${getPaidPercents(
                  data.amount,
                  data.left_to_pay_sum,
                  payment
                )}%`,
              }"
            ></div>
          </div>
          <div
            class="text-size-xs"
            :class="`${
              getPaidPercents(data.amount, data.left_to_pay_sum, payment) ===
              100
                ? 'text-primary'
                : 'text-grey'
            }`"
          >
            {{ $getFormattedDate(payment.plane_date, "DD MMMM") }} <br />
            {{ $currencyFormatter(payment.payment_amount) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: [Object, null],
      required: true,
    },
    multiline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cdnUrl: "https://static.cdn-kaspi.kz/kkz/bank/icons/bymerchantid/",
    };
  },
  computed: {
    operationTypeLogos() {
      return {
        SHOP: "i-shop-logo",
        TRANSFER: "i-transfer-logo",
        PREPAYMENT: "i-prepayment-logo",
        PAY_INVOICE: "i-pay-invoice-logo",
        OPER: "custom",
      };
    },
    isOperType() {
      return (
        this.data.operation_type === "OPER" ||
        this.data.transaction_type === "SHOP"
      );
    },
    isHoldTypeIcon() {
      return "i-hold-timer"
    },
  },
  methods: {
    setAltImg(e, name) {
      const logoContainer = e.target.parentNode;
      logoContainer.classList.add("payment-card__logo--custom");
      logoContainer.setAttribute("data-logo", name[0]);
    },
    getBonusAmount(amount, percents) {
      return this.$currencyFormatter((amount * percents) / 100, "BONUS", 2);
    },
    getPaidPercents(totalSum, leftSum, payment) {
      if (leftSum === totalSum) {
        return 0;
      }
      const reverseNumber = (num, max) => max - num + 1;
      const currentStepAmount =
        payment.payment_amount * reverseNumber(payment.payment_number, 3) -
        leftSum;
      if (leftSum === 0 || currentStepAmount > payment.payment_amount) {
        return 100;
      }
      return parseInt((currentStepAmount * 100) / payment.payment_amount);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

$logo-diameter: 38px;

.payment-card {
  display: flex;
  align-items: flex-start;
  padding: 16px 15px;
  background-color: white;
  text-align: left;

  &__logo {
    position: relative;
    text-align: center;
    min-width: $logo-diameter;
    max-width: $logo-diameter;
    height: $logo-diameter;

    &--cancel {
      position: absolute;
      top: -2px;
      right: -2px;
    }

    &--replenishment {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: $logo-diameter;
      height: $logo-diameter;
      background-color: $colorRed;
      border-radius: 50%;
      overflow: hidden;
    }

    & > img {
      width: 100%;
      height: 100%;
    }

    &--custom {
      position: relative;
      width: $logo-diameter;
      height: $logo-diameter;
      background-color: $colorRed;
      border-radius: 50%;

      & > img {
        display: none;
      }

      &::before {
        content: attr(data-logo);
        position: absolute;
        left: 50%;
        line-height: $logo-diameter;
        transform: translate(-50%);
        font-size: 22px;
        color: white;
      }
    }
  }

  &__content {
    flex: 1;
    width: calc(80%);
    padding-left: 15px;
    height: calc(100%);
    align-self: center;

    &_text {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      color: $colorTextMain;
      max-width: inherit;
    }

    &_hint {
      margin-top: 4px;
    }

    &_progress {
      margin-top: 8px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .progress-block {
        flex: 1;
        padding-right: 5px;

        &:last-child {
          padding-right: 0px;
        }

        &__mask {
          position: relative;
          background-color: #f0f0f0;
          overflow: hidden;
          width: 100%;
          height: 8px;
          border-radius: 8px;
          margin-bottom: 8px;

          &_filler {
            height: 8px;
            width: 0;
            background-color: #a3db5a;
          }
        }
      }
    }
  }

  &__title {
    margin-right: 10px;
    max-width: calc(100%);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__amount {
    flex: 1;
    width: min-content;
    color: inherit;
    white-space: nowrap;
    text-align: right;
    padding: 0;

    &_bonus {
      margin-top: 4px;
    }
    &_hold {
      display: flex;
      flex-direction: row;
      justify-content: end;
      align-items: center;
    }
  }
}
</style>
